import { getSnapShotData } from "@iewcasia/Services/CustomSnapshotService";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    onSuccess(result: any): any;
}

interface Props {
    apiResult: any;
}

// create a handler chain
type HandlerType = Handler<Parameter, Props> & HasOnSuccess;

// create a handler
export const getData: HandlerType = async props => {
    props.apiResult = await getSnapShotData();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

const chain = [getData, ExecuteOnSuccessCallback];

const customGetSnapShotData = createHandlerChainRunner(chain, "customGetSnapShotData");
export default customGetSnapShotData;
